import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

export const AcceptTermsMutation: TypedDocumentNode<AcceptTermsResponse, AcceptTermsVariables> = gql`
  mutation AcceptTerms($tosVersion: String!) {
    acceptUserTerms(tosVersion: $tosVersion) {
      tosVersion
    }
  }
`;

export type AcceptTermsResponse = {
  acceptUserTerms: {
    tosVersion: string;
  };
};

export type AcceptTermsVariables = {
  tosVersion: string;
};
